<template>
  <RouterLink
    v-for="item of cities"
    :to="item.to"
    class="inline-block mr-4 mb-4 rounded-md bg-primary px-4 py-2 text-btn-forecolor">
    {{ $t(item.label) }}
  </RouterLink>
</template>
<script setup>
import { RouterLink } from "vue-router";

defineProps({
  cities: { required: true },
});
</script>
